<div id="overlay">
  <table class="wrapper">
    <tr>
      <td>
        <div id="dummy-overlay" (click)="onCloseClick($event)"></div>
        <div class="pop-up-container">
          <img
            class="popupimg"
            src="assets/images/common/popup_bg_medium.webp?t={{ version }}"
          />

          <img
            class="closeiconImg"
            [appImageSprite]="'close'"
            [params]="menu_icons"
            (click)="onCloseClick($event)"
          />
          <img
            class="lang-specific-desktop-selectinfo-info-icon"
            [appImageSprite]="'info_icon'"
            [params]="common_icons"
          />
          <div
            class="lang-specific-text-content-select-div lang-specific-selectinfo-desktop-info-header lang-specific-font-name"
            [ngStyle]="{
              'text-transform': currentLanguage == 'ge' ? 'none' : 'uppercase'
            }"
          >
            {{ 'LANG00143' | translate }}
          </div>
          <div
            class="lang-specific-text-content-select-div lang-specific-pick-header-select lang-specific-font-name"
          >
            {{ 'LANG00142' | translate }}
          </div>
          <div
            [ngClass]="[isMac + 'lang-specific-option-container-select']"
            class="lang-specific-option-container-select"
          >
            <ul>
              <li *ngFor="let info of infoArr; let i = index">
                <img
                  class="lang-specific-option-img-div"
                  [appImageSprite]="optionImage['image_' + info.selected]"
                  [params]="menu_icons"
                />
                <div
                  class="lang-specific-text-content-select-div lang-specific-gameName-info-text lang-specific-font-name"
                >
                  <span>{{ info.name | translate }}</span>
                </div>
                <div
                  class="option-cover"
                  (mouseover)="buttonOverOrOut(i)"
                  (mouseout)="buttonOverOrOut(i)"
                  (click)="buttonClick(i)"
                ></div>
              </li>
            </ul>
          </div>
        </div>
      </td>
    </tr>
  </table>
</div>
